import React, { type ReactNode } from "react";

import { CompanyProvider, useCompanies } from "./CompanyContext";
import {
  FacilityCareTeamProvider,
  useFacilityCareTeams,
} from "./FacilityCareTeamContext";
import { FacilityProvider, useFacilities } from "./FacilityContext";
import { HealthPlanProvider, useHealthPlans } from "./HealthPlanContext";
import { OrganizationProvider, useOrganizations } from "./OrganizationContext";
import {
  ProviderProfileProvider,
  useProviderProfiles,
} from "./ProviderProfileContext";

export {
  CompanyProvider,
  useCompanies,
  FacilityCareTeamProvider,
  useFacilityCareTeams,
  FacilityProvider,
  useFacilities,
  OrganizationProvider,
  useOrganizations,
  HealthPlanProvider,
  useHealthPlans,
  ProviderProfileProvider,
  useProviderProfiles,
};

interface ProviderDirectoryContextProps {
  children: ReactNode;
}

export const ProviderDirectoryContextProvider = ({
  children,
}: ProviderDirectoryContextProps) => (
  <OrganizationProvider>
    <FacilityCareTeamProvider>
      <FacilityProvider>
        <CompanyProvider>
          <HealthPlanProvider>
            <ProviderProfileProvider>{children}</ProviderProfileProvider>
          </HealthPlanProvider>
        </CompanyProvider>
      </FacilityProvider>
    </FacilityCareTeamProvider>
  </OrganizationProvider>
);
